import Cookies from "js-cookie";
import api from "./api";

export const isAuthenticated = () => localStorage.getItem("inova") !== null;

export const isAdmin = async () => {
  try {
    const { data } = await api.get(`/verifiAdm`);
    if (data.isAdmin) {
      return { status: "success", isAdmin: true };
    } else {
      return { status: "error", isAdmin: false };
    }
  } catch (error) {
    console.error("Erro ao verificar se o usuário é admin:", error);
    console.log(localStorage.getItem("inova"));

    return { status: "error", isAdmin: false };
  }
};

export const getToken = () => localStorage.getItem("inova");
export const getTokenn = () => Cookies.get("Inova");

export const logout = () => localStorage.removeItem("inova");
export const logoutt = () => Cookies.remove("Inova");